import type { AppPreviewGalleryInternalState } from "../next/AppPreviewGallery.types";

export const useToggleExpandedState = (
  state: AppPreviewGalleryInternalState,
  setState: React.Dispatch<React.SetStateAction<AppPreviewGalleryInternalState>>
) => {
  const handleToggle = () => {
    setState({ ...state, expanded: !state.expanded });
  };

  return handleToggle;
};
